import { useMemo } from "react";
import { useQuery } from "urql";
import { graphql } from "@acto/gql";
import { hasClient, Meeting } from "@acto/taskpane/core/domain";

const MeetingsAwaitingRecapQuery = graphql(`
  query GetMeetingsAwaitingRecap($clientId: ID) {
    meetingsAwaitingRecap(clientId: $clientId) {
      id
      __typename
      scheduledDate
      scheduledStartTime
      scheduledEndTime
      occurrenceDate
      series {
        id
        __typename
        cadence
        startDate
        until
        scheduledStartTime
        scheduledEndTime
      }
      client {
        id
        legacyId
        __typename
        name
        externalReference
      }
    }
  }
`);

export function useMeetingsAwaitingRecap({ clientId }: { clientId?: string } = {}) {
  const [result, refetch] = useQuery({
    query: MeetingsAwaitingRecapQuery,
    variables: { clientId },
  });

  const meetings = useMemo(
    () => result.data?.meetingsAwaitingRecap.filter(hasClient).map(Meeting.fromGraphql),
    [result.data],
  );

  return {
    data: meetings,
    isFetching: result.fetching || Boolean(result.stale),
    isPending: (result.fetching || Boolean(result.stale)) && !result.data,
    error: result.error,
    refetch,
  };
}
